import styled, { css } from 'styled-components';

export const Container = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;

  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};

  appearance: none;
  border: 0;
  background: transparent;
  font: inherit;
  color: inherit;
  text-align: left;

  border-radius: ${({ theme }) => theme.spacing(2.5)};
  transition: background 200ms;
  cursor: pointer;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: ${theme.spacing(1.5)} ${theme.spacing(3)} ${theme.spacing(1.5)}
        ${theme.spacing(1)};
    `};

  ${({ $selected, theme }) =>
    $selected &&
    css`
      background: ${theme.palette.primaryExtended.opacityBackgroundBackground};
    `};
`;

export const TitleArea = styled.span<{ $completed: boolean }>`
  flex: 0 1 auto;
  min-width: 0;
  display: flex;

  ${({ $completed }) =>
    $completed &&
    css`
      opacity: 0.5;
    `};
`;
